import { __assign, __rest } from "tslib";
import * as React from "react";
import classnames from "classnames";
import "./Button.css";
var vartiantClassMap = {
    primary: "button-primary",
    secondary: "button-secondary",
    ternary: "button-ternary",
    cta: "button-cta",
    danger: "button-danger"
};
export var Button = React.forwardRef(function (props, ref) {
    var children = props.children, className = props.className, _a = props.disabled, disabled = _a === void 0 ? false : _a, flat = props.flat, icon = props.icon, slim = props.slim, type = props.type, _b = props.variant, variant = _b === void 0 ? "secondary" : _b, rest = __rest(props, ["children", "className", "disabled", "flat", "icon", "slim", "type", "variant"]);
    var variantClass = vartiantClassMap[variant];
    var buttonClass = classnames("button", variantClass, className, {
        "button--disabled": disabled,
        "button--flat": flat,
        "button--slim": slim,
        "button--round": !children && icon
    });
    return "href" in props ? (React.createElement("a", __assign({ className: buttonClass, onMouseDown: function (e) { return e.preventDefault(); } }, rest, { href: disabled ? undefined : props.href, ref: ref }),
        icon !== undefined && React.createElement("span", { className: "button-icon" }, icon),
        children)) : (React.createElement("button", __assign({ className: buttonClass, disabled: disabled, onMouseDown: function (e) { return e.preventDefault(); }, type: type || "button" }, rest, { ref: ref }),
        icon !== undefined && React.createElement("span", { className: "button-icon" }, icon),
        children));
});
Button.displayName = "Button";
export default Button;
